import { Injectable, Injector } from '@angular/core';
import { AuthStore } from '@lemsar/storage/stores/auth.store';

@Injectable()
export class GlobalStoreService {
    public constructor(private injector: Injector) {}

    public init(): Promise<void> {
        return this.injector.get(AuthStore).init();
    }
}



// WEBPACK FOOTER //
// ./src/lemsar/storage/services/global-store.service.ts